<template>
  <div id="err">
    <h1>404</h1>
    <p>The page cannot be found</p>
  </div>
</template>

<script>
export default {
  name: "Err",
};
</script>

<style scoped>
#err {
  height: 3rem;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  text-align: center;
}
h1 {
  font-size: 0.4rem;
}
p {
  font-size: 0.26rem;
  color: #636363;
}
</style>
